import { useEffect } from "react";

export function useLockBackNavigation(enabled: boolean): void {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    globalThis.history.pushState(null, "", globalThis.location.href);

    const handlePopState = () => {
      globalThis.history.pushState(null, "", globalThis.location.href);
    };

    globalThis.addEventListener("popstate", handlePopState);
    return () => globalThis.removeEventListener("popstate", handlePopState);
  }, [enabled]);
}
